import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QRCodeService {
  private qrDataSubject: Subject<string> = new Subject<string>();
  qrData$ = this.qrDataSubject.asObservable();

  updateQRData(qrData: string) {
    this.qrDataSubject.next(qrData);
  }
}
